//
//
//
//

export default {
    props: {
        name: String,
        size: String,
        disable: Boolean,
    },

    computed: {
        clickable() {
            return !!this.$listeners.click;
        },
    },
};
